'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const LightbulbIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.5692 16.3319L15.3192 16.3341L15.3236 14.8341L14.5736 14.8319L14.5692 16.3319ZM9.45349 14.8168L8.70349 14.8146L8.69907 16.3146L9.44907 16.3168L9.45349 14.8168ZM16.1219 14.8853L15.6646 14.2908L15.6645 14.2909L16.1219 14.8853ZM15.2569 15.5668L14.7863 14.9829L14.5069 15.2081V15.5668H15.2569ZM8.75777 15.5668H9.50777V15.1981L9.21582 14.973L8.75777 15.5668ZM7.89904 14.8853L8.35638 14.2909L8.35633 14.2908L7.89904 14.8853ZM14.5736 14.8319L9.45349 14.8168L9.44907 16.3168L14.5692 16.3319L14.5736 14.8319ZM6.0105 9.53013C6.0105 6.21523 8.69697 3.52832 12.0105 3.52832V2.02832C7.86816 2.02832 4.5105 5.38718 4.5105 9.53013H6.0105ZM12.0105 3.52832C15.324 3.52832 18.0105 6.21523 18.0105 9.53013H19.5105C19.5105 5.38718 16.1528 2.02832 12.0105 2.02832V3.52832ZM18.0105 9.53013C18.0105 11.4687 17.0925 13.1925 15.6646 14.2908L16.5792 15.4798C18.3604 14.1096 19.5105 11.954 19.5105 9.53013H18.0105ZM15.6645 14.2909C15.3223 14.5543 15.1499 14.6898 14.7863 14.9829L15.7276 16.1508C16.0825 15.8647 16.246 15.7361 16.5793 15.4797L15.6645 14.2909ZM14.5069 15.5668V17.3472H16.0069V15.5668H14.5069ZM14.5069 17.3472C14.5069 17.4474 14.4257 17.5283 14.326 17.5283V19.0283C15.2544 19.0283 16.0069 18.2755 16.0069 17.3472H14.5069ZM14.326 17.5283H9.68868V19.0283H14.326V17.5283ZM9.68868 17.5283C9.58895 17.5283 9.50777 17.4474 9.50777 17.3472H8.00777C8.00777 18.2755 8.76016 19.0283 9.68868 19.0283V17.5283ZM9.50777 17.3472V15.5668H8.00777V17.3472H9.50777ZM9.21582 14.973C9.03549 14.8339 8.91094 14.7331 8.78641 14.6322C8.66064 14.5303 8.53341 14.4271 8.35638 14.2909L7.44169 15.4797C7.60245 15.6034 7.71688 15.6962 7.84217 15.7977C7.96871 15.9002 8.10463 16.0102 8.29971 16.1607L9.21582 14.973ZM8.35633 14.2908C6.9285 13.1925 6.0105 11.4687 6.0105 9.53013H4.5105C4.5105 11.9539 5.66059 14.1096 7.44174 15.4798L8.35633 14.2908ZM8 22H16V20.5H8V22Z",
        fill: "currentColor"
      }
    )
  }
);
const VpLightbulbIcon = forwardRef(LightbulbIcon);

export { VpLightbulbIcon as default };
